import React, { useContext } from 'react';
import { KICK_STRENGTH } from '../../constants/constants';
import { KickCounterContext } from '../../context/KickCounterContext';
import styles from './KickStrengthInput.module.css';

export default function KickStrengthInput() {
  const { setSessionStrength, strength } = useContext(KickCounterContext);

  const handleClick = (value) => {
    setSessionStrength(value);
  };

  const setButtonStyle = (value) => (strength >= value
    ? styles.circleActive : styles.circleNotActive);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.buttonContainer}>
        <button type="button" aria-label={KICK_STRENGTH.VERY_LIGHT} onClick={() => handleClick(1)} className={setButtonStyle(1)} />
        {KICK_STRENGTH.VERY_LIGHT}
      </div>
      <div className={styles.buttonContainer}>
        <button type="button" aria-label={KICK_STRENGTH.LIGHT} onClick={() => handleClick(2)} className={setButtonStyle(2)} />
        {KICK_STRENGTH.LIGHT}
      </div>
      <div className={styles.buttonContainer}>
        <button type="button" aria-label={KICK_STRENGTH.MODERATE} onClick={() => handleClick(3)} className={setButtonStyle(3)} />
        {KICK_STRENGTH.MODERATE}
      </div>
      <div className={styles.buttonContainer}>
        <button type="button" aria-label={KICK_STRENGTH.STRONG} onClick={() => handleClick(4)} className={setButtonStyle(4)} />
        {KICK_STRENGTH.STRONG}
      </div>
      <div className={styles.buttonContainer}>
        <button type="button" aria-label={KICK_STRENGTH.VERY_STRONG} onClick={() => handleClick(5)} className={setButtonStyle(5)} />
        {KICK_STRENGTH.VERY_STRONG}
      </div>
    </div>
  );
}
